module.exports = __webpack_public_path__ + "files/34fa6e28e3f9d9746d9008850ade09f9.png";